import { IInputMethodBehavior } from "./IInputMethodBehavior";

export interface IInputMethodBehaviorSpecifiable {
  inputMethodBehavior: IInputMethodBehavior;
}

export function instanceOfIInputMethodBehaviorSpecifiable(instance: any): instance is IInputMethodBehaviorSpecifiable {
  return instance
    && (instance.inputMethodBehavior !== undefined);
}
